module.exports = __webpack_public_path__ + "static/media/Gale-Sayers-Foundation-Logo-Hi-Res.c20020f7.jpg";